// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionHeader_container__xb-sh","description":"SectionHeader_description__3ArPq"};